import authentication from './authentication'
import { combineReducers } from 'redux'
import paths from './paths'

export default combineReducers({
  authentication,
  paths
})